import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Card } from '@components/molecules/Card/Card';
import { ColumnsLayout } from '@components/templates/ColumnsLayout/ColumnsLayout';

import { getPath } from '@services/RouteService/paths';

import { resetReporterDetails } from '@boot/reactiveVariables';
import { CheckStatusForm } from '@domains/auth/organisms/CheckStatusForm/CheckStatusForm';

import {
    ButtonIconTextElement,
    ButtonTextWrapper,
    ButtonWrapper,
    CreateReportContainerSection,
    StatusCard,
} from './CaseStatusPage.styled';

export const CaseStatusPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <ColumnsLayout>
            <StatusCard testId="e6HvAYb">
                <Card.TitleTertiary>
                    {t('CHECK_CASE_STATUS')}
                </Card.TitleTertiary>
                <Card.Description>{t('CHECK_STATUS_INFO')}</Card.Description>
                <CheckStatusForm />
            </StatusCard>
            <CreateReportContainerSection>
                <ButtonWrapper>
                    <ButtonIconTextElement
                        iconProps={{ icon: 'SvgAddNew', size: 24 }}
                        onPress={() => {
                            navigate(getPath({ path: '/new-conversation' }));
                            resetReporterDetails();
                        }}
                        testId="_bvNWqO"
                    >
                        <ButtonTextWrapper>
                            {t('CREATE_NEW_REPORT')}
                        </ButtonTextWrapper>
                    </ButtonIconTextElement>
                </ButtonWrapper>
            </CreateReportContainerSection>
        </ColumnsLayout>
    );
};
